const AttendanceHeader = () => {
  return (
    <div className="aa-header">
      <h1 className="aa-header-title">Annual Attendance</h1>
    </div>
  );
};

export default AttendanceHeader;